const Fonts = {
    NotoSans: 'Noto Sans Georgian',
    Roboto: 'Roboto',
    FiraGoBold: 'FiraGO',
    FiraGoRegular: 'FiraGO',
};

export default Fonts;